import {
	GeneralDocument,
	generalDocumentQuery,
	type ResolvedDoc,
} from '#app/components/general-document.tsx'
import { safeFetch } from '#app/utils/sanity.server.ts'
import { type Route } from './+types/cancel-gammon.ts'

export async function loader() {
	// In Sanity Studio, set the Name field to "cancel-gammon" for this document
	const doc = await safeFetch<ResolvedDoc | null>(
		`*[_type == "generalDocument" && name == "cancel-gammon"][0] ${generalDocumentQuery}`,
	)
	return { doc }
}

export default function CancelGammon({ loaderData }: Route.ComponentProps) {
	return <GeneralDocument doc={loaderData.doc} />
}
